import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axiosCommercial from "../../../Redux/axios/AxiosCommercial";
import {
  setCommercialQuickQuotes,
  setCommercialErrQuotes,
  setQuickQuotePost,
  getComQuickQuotePost,
} from "../../../Redux/actions/CommercialSlice";
import { Button, Form, Radio, message } from "antd/lib";

export default function CommercialOwmeredit({ setisModalOwner, CommerDetail }) {
  const dispatch = useDispatch();
  const auth = CommerDetail?.commercialnum;
  const QuickQuotePost = useSelector(getComQuickQuotePost);
  console.log(QuickQuotePost);
  const [QuotePost, setQuotePost] = useState(QuickQuotePost);
  const [loading, setLoading] = useState(false);

  const onFinish = (data) => {
    console.log("data", data);
    // console.log("dateString",data.registrationDate)
    const updatedQuotePost = {
      ...QuotePost,
      policyHolderType: data.vechicleOwned,
    };
    console.log(updatedQuotePost);
    setLoading(true);
    axiosCommercial
      .post(
        `v2/commercial_insurances/${auth?.commercial_insurance_id}/quick_quotes`,
        updatedQuotePost
      )
      .then((res) => {
        if (res.status === 200) {
          const data = res?.data?.data;
          //console.log("data-----------------",data)
          const errData = data?.filter(
            (item) => "status" in item && item.status === "failed"
          );
          dispatch(setCommercialErrQuotes(errData));
          const filteredData = data?.filter(
            (item) => "status" in item && item.status === "success"
          );
          const updatedData = filteredData?.map((item) => ({
            ...item,
            IsGst: true,
          }));
          dispatch(setCommercialQuickQuotes(updatedData));
          dispatch(setQuickQuotePost(updatedQuotePost));
          setLoading(false);
          setisModalOwner(false);
        }
      })
      .catch((err) => {
        console.log(err.response.data.error);
        setLoading(false);
        message.error(err.response.data.error);
      });
  };
  return (
    <>
      <Form onFinish={onFinish} layout="vertical" requiredMark={false}>
        <Form.Item
          // className="form-item-bg"
          name="vechicleOwned"
          label="Choose the Journey Type"
          rules={[
            {
              required: true,
              message: "Please select",
            },
          ]}
          initialValue={QuotePost?.policyHolderType}
        >
          <Radio.Group
            className="py-3 px-3 bg-white ant-radio-layout"
            style={{
              width: "100%",
            }}
          >
            <Radio value="INDIVIDUAL">Individual</Radio>
            <Radio value="COMPANY">Company</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item style={{ textAlign: "center" }}>
          <Button
            type="primary"
            loading={loading}
            htmlType="submit"
            className="update-qut-button"
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </>
  );
}
